import React, { useState } from 'react';
import {
  AccordionActionBox,
  AccordionBody,
  AccordionContainer,
  AccordionHeader,
  AccordionTitle
} from './style';
import { FiChevronDown } from 'react-icons/fi';

interface AccordionProps {
  title: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export default function Accordion({ title, actions, children }: AccordionProps) {
  const [open, setOpen] = useState<boolean>(true);

  const toggle = () => setOpen(prev => !prev);

  return (
    <AccordionContainer>
      <AccordionHeader>
        <AccordionTitle>{title}</AccordionTitle>
        <AccordionActionBox>
          {actions}
          <button className={`toggle ${open && 'opened'}`} onClick={toggle}>
            <FiChevronDown />
          </button>
        </AccordionActionBox>
      </AccordionHeader>

      {open && <AccordionBody>{children}</AccordionBody>}
    </AccordionContainer>
  );
}
